import { Component, OnChanges , Input} from '@angular/core';
import { FormGroup }        from '@angular/forms';
import { LoginService } from 'src/app/services/login/login.service';

import { FieldBase }     from './field-base';

@Component({
  selector: 'app-dynamic-form-field',
  templateUrl: './dynamic-form-field.component.html',
  styleUrls: ['./dynamic-form-field.component.scss']
})
export class DynamicFormFieldComponent implements OnChanges{
  @Input() field: FieldBase<string>;
  @Input() form: FormGroup;
  userRole: string[];
  constructor(private loginService: LoginService) {}

  ngOnChanges() {
    this.userRole = this.loginService.currentUserValue.rol;
  }
  get isValid() { return this.form.controls[this.field.key].valid; }
}
